<div class="modal-wrapper">
  <div id="range-container">
    <ion-grid>
      <ion-row>
        <ion-col size="12">
          <h5 class="modal-title">Rangos</h5>
        </ion-col>
        <ion-col size="12">
          <p *ngIf="modeCreateLimit">Introduce los siguientes datos para crear un rango</p>
          <p *ngIf="modeEditLimit">A continuación, podrás editar algunos valores de tu rango</p>
          <p *ngIf="modeDelete">¿Estás seguro de que quieres eliminar el rango?</p>
        </ion-col>
      </ion-row>

      <form [formGroup]="form" (ngSubmit)="saveLimit()" #pform="ngForm">
        <ion-row *ngIf="!isDelete()">
          <ion-col size="12">
            <mat-form-field appearance="fill">
              <mat-label>Nombre</mat-label>
              <input matInput formControlName="name">
            </mat-form-field>
          </ion-col>

          <ion-col *ngIf="!isDelete()" size="12">
            <mat-form-field appearance="fill">
              <mat-label>Propiedad</mat-label>
              <mat-select formControlName="property" (selectionChange)="selectOption($event)" [disabled]="isEdit()">
                <mat-option *ngFor="let option of options" [value]="option.value">{{ option.title }}</mat-option>
              </mat-select>
            </mat-form-field>
          </ion-col>

          <ion-col *ngIf="!isDelete()" size="12">
            <mat-form-field appearance="fill">
              <mat-label>Valor inferior</mat-label>
              <input matInput type="number" formControlName="minValue">
            </mat-form-field>
          </ion-col>

          <ion-col *ngIf="!isDelete()" size="12">
            <mat-form-field appearance="fill">
              <mat-label>Valor superior</mat-label>
              <input matInput type="number" formControlName="maxValue">
            </mat-form-field>
            <mat-error *ngIf="form.hasError('minGreaterOrEqualMax')">
              El valor inferior debe ser menor que el superior*.
            </mat-error>
          </ion-col>

          <ion-col *ngIf="!isDelete()" size="12">
            <mat-checkbox formControlName="isVisible" (change)="onChangeVisibility($event)">¿Visible en el
              gráfico?</mat-checkbox>
          </ion-col>

          <ion-col *ngIf="!isDelete()" size="6">
            <mat-label style="display:block">Selecciona el color</mat-label>
            <input class="limit-color" [(colorPicker)]="color" [style.background]="color" [cpOutputFormat]="'hex'"
              style="display: block; width: 100%; height: 40px; margin: 0; padding: 8px; box-sizing: border-box;" />
          </ion-col>

        </ion-row>

        <ion-row id="limit-container-footer">
          <ion-col>
            <button *ngIf="isEdit()" type="submit" mat-raised-button color="primary"
              [disabled]="!checkValues() || isSaving">Actualizar</button>
            <button *ngIf="!isEdit() && !isDelete()" type="submit" mat-raised-button color="primary"
              [disabled]="!checkValues() || isSaving">Guardar</button>
            <button *ngIf="isDelete()" type="button" mat-raised-button (click)="deleteLimit()" class="me-3"
              color="warn">Eliminar Rango</button>
            <button type="button" mat-raised-button (click)="closeModal()" class="me-3" color="medium">Cancelar</button>
          </ion-col>
        </ion-row>
      </form>
    </ion-grid>
  </div>
</div>